<template>
	<div>
		<!-- MOCK: here we should be able to fetch particular CMS component based on componentName -->
		<component :is="componentName" v-if="!isLoading" />
		<div v-else class="xs-12 flex xs-center p4">
			<j-spinner />
		</div>
	</div>
</template>

<script>
// import api from "@/api/gql.js"
// import { gql } from "@/api/utils.js"
import JSpinner from "@/components/JSpinner"

// MOCK CMS templates that are in codebase but should come from CMS microservice eventually
import CaseJewellersBlock from "../components/mockedAeg/CaseJewellersBlock"
import CasePersonalJewellery from "../components/mockedAeg/CasePersonalJewellery"
import CaseCommercialBlock from "../components/mockedAeg/CaseCommercialBlock"
import CaseSending from "../components/mockedAeg/CaseSending"
import CaseJewellersTour from "../components/mockedAeg/CaseJewellersTour"
import CaseJewellersExhibition from "../components/mockedAeg/CaseJewellersExhibition"
import CaseEmployeesCompensation from "../components/mockedAeg/CaseEmployeesCompensation"
import CasePublicLiability from "../components/mockedAeg/CasePublicLiability"
import CaseHome from "../components/mockedAeg/AegCaseHome"

// MOCK: CMS berkley - only POC, it will be possible to delete from codebase
import CaseProductsLiability from "../components/mockedBerkley/CaseProductsLiability"

// MOCK: CMS HKECIC - only POC, it will be possible to delete from codebase
import CaseExportCredit from "../components/mockedHkecic/CaseExportCredit"

// MOCK: CMS FiLife/Muangthai/Lapetus - only POC, it will be possible to delete from codebase
import CaseLife from "../components/mockedFiLife/CaseLife"

import AsiaCaseDetailGeneric from "../components/mockedAsia/AsiaCaseDetailGeneric"

// MOCK: CMS CompanyCover
import CaseGroupMedical from "../components/mockedCompanyCover/CaseGroupMedical"

// MOCK: CMS Apeiron Agent Portal flow
import ApeironCaseHome from "../components/mockedApeiron/ApeironCaseHome"

// MOCK: Bupa - only POC, it will be possible to delete from codebase
import CaseBupa from "../components/mockedBupa/CaseBupa"

// MOCK: CMS Demo2
import Demo2CaseHome from "../components/mockedDemo2/Demo2CaseHome"

// MOCK: CMS Demo
import DemoCaseProductsLiability from "../components/mockedDemo/CaseProductsLiability"
// import DemoCasePropertyAllRisks from "../components/mockedDemo/CasePropertyAllRisks"
import CaseOfficeInsurance from "../components/mockedDemo/CaseOfficeInsurance"
import CasePropertyAllRisks from "../components/mockedDemo/CasePropertyAllRisks/Template"

// MOCK: CMS aia_uat - only POC
import CaseTravel from "../components/mockedAia/CaseTravel"

export default {
	components: {
		JSpinner,

		//MOCK: CMS AEG
		CaseJewellersBlock,
		CasePersonalJewellery,
		CaseCommercialBlock,
		CaseSending,
		CaseJewellersTour,
		CaseJewellersExhibition,
		CaseEmployeesCompensation,
		CasePublicLiability,

		//MOCK: CMS Demo
		CasePropertyAllRisks,

		//MOCK: CMS Demo2
		Demo2CaseHome,

		// Case Home v1
		CaseHome,

		//MOCK: CMS Berkley
		CaseProductsLiability,

		// MOCK: CMS CompanyCover
		CaseGroupMedical,

		// MOCK: CMS HKECIC
		CaseExportCredit,

		// MOCK: CMS FiLife
		CaseLife,

		// MOCK: CMS Apeiron
		ApeironCaseHome,

		// MOCK: Bupa
		CaseBupa,

		// MOCK: AIA
		CaseTravel,

		// MOCK: ASIA
		AsiaCaseDetailGeneric
	},

	props: {
		// From router
		id: String
	},

	data() {
		return {
			isLoading: false
		}
	},

	computed: {
		componentName() {
			// For HKECIC we hardcode the name of the component "CaseExportCredit"
			if (
				this.$store.state.tenantId === "hkecic_uat" ||
				this.$store.state.tenantId === "hkecic"
			)
				return "CaseExportCredit"

			// For FiLife we hardcode the name of the component "CaseLife"
			if (
				this.$store.state.tenantId === "fiLife_uat" ||
				this.$store.state.tenantId === "fiLife" ||
				this.$store.state.tenantId === "muangThai_uat" ||
				this.$store.state.tenantId === "muangThai" ||
				this.$store.state.tenantId === "lapetus_uat" ||
				this.$store.state.tenantId === "lapetus" ||
				this.$store.state.tenantId === "companyCover_uat" ||
				this.$store.state.tenantId === "digitalBroker"
			)
				return "CaseLife"

			if (this.$store.state.tenantId === "apeiron_uat") return "ApeironCaseHome"

			// for bupa_uat we hardcode the name of component "CaseBupa"
			if (this.$store.state.tenantId === "bupa_uat") return "CaseBupa"

			// For Demo_uat and Demo2_uat, we display same as berkley_uat
			if (
				this.$store.state.tenantId === "demo_uat" ||
				this.$store.state.tenantId === "demo2_uat"
			) {
				const mapping = {
					CaseProductsLiability: DemoCaseProductsLiability,
					CaseOfficeInsurance: CaseOfficeInsurance,
					CasePropertyAllRisks: CasePropertyAllRisks
					// CasePropertyAllRisks: DemoCasePropertyAllRisks
				}

				const component = this.$store.state.caseManagement?.case?.component
					?.name
				return mapping[component] || component
			}

			// For AIA we hardcode the name of the component
			if (
				this.$store.state.tenantId === "aia_uat" ||
				this.$store.state.tenantId === "raghav_uat"
			)
				return "CaseTravel"

			// For Asia we hardcode the name of the component
			if (["asia_uat", "asia"].includes(this.$store.state.tenantId))
				return "AsiaCaseDetailGeneric"

			// For rest we display case component based on component.name
			return this.$store.state.caseManagement?.case?.component?.name
		}
	},

	methods: {
		// Fetch all data for the case and save in store
		async initCase() {
			// Fetch case data and also proposals data into store
			this.isLoading = true
			const res = await Promise.all([
				this.$store.dispatch("caseManagement/fetchCase", {
					caseId: this.id
				}),
				this.$store.dispatch("caseManagement/fetchProposals", {
					caseId: this.id
				})
			])
			this.isLoading = false

			// If there is no case, rediret to list view
			if (!res?.[0]?.data?.cases?.list?.length)
				this.$router.push({ name: "CaseManagementList" })
		}
	},

	created() {
		// Flush store data
		this.$store.commit("caseManagement/SET_PROPOSAL_ID", null)
		this.$store.commit("caseManagement/SET_OFFER_ID", null)

		// Set caseId from route
		this.$store.commit("caseManagement/SET_CASE_ID", this.id)

		// Init case
		this.initCase()
	}
}
</script>
